<div class="container-fluid">
    <app-pagetitle title="Documents" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

    
    <div class="page-content-wrapper">
        
        <app-loader [loading]="loading"></app-loader>
        
        <div [class.loading-content]="loading">




            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <app-filter (filterChange)="filterChange($event)"
                                searchBY="Document Id, Document Name, Customer Name"
                                [statusOptions]="statusOptions"></app-filter>

                            <p-table #dt [value]="documents" [lazy]="true" (onLazyLoad)="getDocuments($event)"
                                [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" 
                                [rowsPerPageOptions]="[10,20,50]" responsiveLayout="scroll"
                                styleClass="p-datatable-sm fs-6" [showCurrentPageReport]="true"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Document Id</th>
                                        <th>Document Name</th>
                                        <th>Customer Name</th>
                                        <th class="text-center">Status</th>
                                        <th>Progress</th>
                                        <th>Total Signers</th>
                                        <th>Created</th>
                                        <th>Action</th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-document>
                                    <tr>
                                        <td class="fw-bold">{{document.documentId}}</td>
                                        <td>{{document.name}}</td>
                                        <td>{{document.customerName}}</td>


                                        <td>
                                            <span class="badge rounded-pill border px-3 p-2" [ngClass]="{
                                        'border-warning text-warning bg-warning-subtle':
                                          document.status?.toLowerCase() === 'pending',
                                        'border-purple text-purple bg-purple-subtle':
                                          document.status?.toLowerCase() !== 'pending'
                                      }">
                                                {{ document.status }}
                                            </span>
                                        </td>
                                        <td>
                                            <div class="progress" style="height: 12px;">
                                                <div class="progress-bar" role="progressbar"
                                                    [style.width.%]="getUserStatus(document.signers)" aria-valuemin="0"
                                                    aria-valuemax="100"> {{document.completedSigners }} / {{
                                                    document.totalSigners }}
                                                </div>
                                            </div>
                                        </td>
                                        <td class="text-center">{{document.totalSigners}}</td>
                                        <td>{{document.createdAt | date}}</td>

                                        <td>
                                            <button class="btn btn-sm btn-outline-primary"
                                                (click)="getDocument(document)">
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="9" class="text-center py-4 text-muted">
                                            <i class="mdi mdi-database-off-outline me-2"></i>
                                            No document found
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        @if(showModal){
        <div class="modal fade show d-block">
            <div class="modal-dialog">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title">Document Details</h5>
                        <button class="btn-close" (click)="closeModal()"></button>
                    </div>

                    <div class="modal-body">
                        <div class="row mb-3">
                            <div class="col-12 text-start mb-3">
                                <div class="label fw-semibold">Document ID</div>
                                <div class="value fw-bold fs-6">{{documentDetail.documentId}}</div>
                            </div>
                            <div class="col-12 text-start mb-3">
                                <div class="label fw-semibold">Name</div>
                                <div class="value">{{documentDetail.name }}</div>
                            </div>
                            <div class="col-12 text-start mb-3">
                                <div class="label fw-semibold">Customer Name</div>
                                <div class="value">{{documentDetail.customerName }}</div>
                            </div>
                            <div class="col-12 text-start mb-3">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="label fw-semibold">Status</div>
                                        <div class="value fw-bold fs-5"> <span
                                                class="badge rounded-pill border px-2 p-1" [ngClass]="{
                                        'border-warning text-warning bg-warning-subtle':
                                          documentDetail.status?.toLowerCase() === 'pending',
                                        'border-purple text-purple bg-purple-subtle':
                                          documentDetail.status?.toLowerCase() !== 'pending'
                                      }">
                                                {{documentDetail.status }}
                                            </span></div>
                                    </div>
                                    <div class="col-6">
                                        <div class="label fw-semibold">Signing Order</div>
                                        <div class="value ">{{documentDetail.signingOrder | titlecase}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 text-start mb-3">
                                <div class="label fw-semibold">Message</div>
                                <div class="value">{{documentDetail.message || documentDetail.description || 'N/A'}}
                                </div>
                            </div>
                            <div class="col-12 text-start mb-3">
                                <div class="label fw-semibold">Recipients</div>
                                @for(signer of documentDetail?.signers; track signer; let i = $index ){
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <div class="d-flex align-items-center">
                                        <div class="value me-2">{{i + 1}}. {{signer?.name | titlecase}}</div>
                                        <span class="badge rounded-pill border px-2 p-1" [ngClass]="{
                                    'border-warning text-warning bg-warning-subtle': signer.status?.toLowerCase() === 'pending',
                                    'border-purple text-purple bg-purple-subtle': signer.status?.toLowerCase() !== 'pending'
                                }">
                                            {{ signer?.status || 'N/A' }}
                                        </span>
                                    </div>
                                </div>
                                }
                            </div>
                            <div class="col-12 text-start">
                                <div class="label fw-semibold mb-1">Signing Progress</div>
                                <div class="progress" style="height: 12px;">
                                    <div class="progress-bar" role="progressbar"
                                        [style.width.%]="getUserStatus(documentDetail.signers)" aria-valuemin="0"
                                        aria-valuemax="100">
                                        {{
                                        documentDetail.completedSigners }} / {{ documentDetail.totalSigners }}
                                    </div>
                                </div>
                                <div class="value">
                                    {{ documentDetail.completedSigners }} signed
                                    of
                                    {{ documentDetail.totalSigners }}
                                    signers completed.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }

        @if(showModal){
        <div class="modal-backdrop fade show"></div>
        }

    </div>
</div>